import Section from '~/components/flp/Section';
import { ANALYTICS_EVENTS } from '~/constants/flp/analyticsEvents';
import ShopDown from './ShopDown';
import ShopPayment from './ShopPayment';
import { Container, ShopTermsSection } from './ShopTerms.styles';

export default function ShopTerms() {
  return (
    <Section
      as={ShopTermsSection}
      eventName={ANALYTICS_EVENTS.PREQUALIFIED.SECTION_VIEWED_SHOPTERMS}
    >
      <Container>
        <ShopPayment />
        <ShopDown />
      </Container>
    </Section>
  );
}
